import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableLocalDeliveryDriverTip = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableLocalDeliveryDriverTip);
};
